import { render, staticRenderFns } from "./SactinMobileApp.vue?vue&type=template&id=4dd24314&scoped=true&"
import script from "./SactinMobileApp.vue?vue&type=script&lang=js&"
export * from "./SactinMobileApp.vue?vue&type=script&lang=js&"
import style0 from "./SactinMobileApp.vue?vue&type=style&index=0&id=4dd24314&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd24314",
  null
  
)

export default component.exports